import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {AttachedDocumentsModel} from '@app/model/attached-documents.model';
import {ConfigService} from '@dcp/configurator';
import {Country} from '@spartacus/core';

@Component({
  selector: 'dcp-cart-header-information-item',
  templateUrl: './cart-header-information-item.component.html',
  styleUrls: ['./cart-header-information-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartHeaderInformationItemComponent {

  constructor(private configService: ConfigService) {
  }

  @Input() showSeparator: boolean = false;
  @Input() titleText: string;
  @Input() firstName: string;
  @Input() lastName: string;
  @Input() email: string;
  @Input() country: Country;
  @Input() companyName: string;
  @Input() industry: string;
  @Input() formattedAddress: string;
  @Input() paymentName: string;
  @Input() documents: AttachedDocumentsModel[];
  @Input() isCurrentUserIndividual: boolean | undefined;
  @Input() cartIsLoading: boolean = false;

  documentsDownloadUrlFolder = '/medias/';

  generatePath(url: string): string {
    return `${this.configService.getString('backend.occ.baseUrl')}${url}`;
  }

  transformName(url: string): string {
    if (typeof url !== 'string') {
      throw new TypeError(`Expected a string for 'url', but got ${typeof url}`);
    }
    return url?.slice(this.documentsDownloadUrlFolder.length)?.split('?')[0];
  }

  showTitle(title: string, documents: AttachedDocumentsModel[]) {
    return title !== 'cart.taxExemptionDoc' || documents.length;
  }
}
